// El proximo juego: la pregunta que un coach y un papa hacen mas que ninguna otra.
//
// No aparecia en ningun lado -- ni en la tarjeta del torneo, ni en su encabezado --
// aunque el dato lleva ahi desde siempre. Las apps grandes abren justo con esto.
//
// "Proximo" es el mas cercano que TODAVIA NO SE JUEGA. Un juego terminado o cancelado no
// es proximo aunque su fecha sea futura (un torneo puede cancelar por adelantado), y uno
// de hoy SI lo es hasta que alguien lo cierre: a las 8 de la manana el partido de las 10
// sigue siendo el proximo.

import { getMexicoDateString } from './dateUtils'

// Estados que sacan a un juego de la fila, pase lo que pase con su fecha.
const YA_NO_ESPERA = new Set(['terminado', 'cancelado'])

export const proximoJuego = (juegos, hoy = getMexicoDateString()) => {
  const candidatos = (juegos || []).filter((j) => {
    if (!j || !j.fecha) return false
    if (YA_NO_ESPERA.has(String(j.estatus || '').toLowerCase())) return false
    // Se compara como texto ISO (YYYY-MM-DD): mismo orden que la fecha y sin zonas
    // horarias de por medio, que es de donde salen los errores de un dia.
    return j.fecha >= hoy
  })
  if (candidatos.length === 0) return null

  // El mas cercano. A igual fecha manda la hora; un juego sin hora va al final de su dia,
  // porque no se puede afirmar que sea antes que uno con hora puesta.
  return candidatos.reduce((mejor, j) => {
    if (j.fecha !== mejor.fecha) return j.fecha < mejor.fecha ? j : mejor
    const ha = j.hora || '99:99'
    const hb = mejor.hora || '99:99'
    return ha < hb ? j : mejor
  })
}
